module.exports = __webpack_public_path__ + "img/PPMP27.64296c39.png";